/* eslint-disable */
const ANDROID_APPID = 'wxfd18336233a6510d'

const iOS_APPID = 'wx677021ef697f33d4'

const ANDROID_DOWNLOAD_URL =
  'https://a.app.qq.com/o/simple.jsp?pkgname=com.jiahk.jiahuakuang&fromcase=40003'

const iOS_DOWNLOAD_URL = 'https://apps.apple.com/cn/app/id1635507522'

/// 初始化微信网页能力
function initWxWebConfig(config) {
  wx.config({
    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    appId: 'wx541c2f62f9682a59', // 必填，公众号的唯一标识
    timestamp: config.timestamp, // 必填，生成签名的时间戳
    nonceStr: config.nonceStr, // 必填，生成签名的随机串
    signature: config.signature, // 必填，签名
    jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'], // 必填，需要使用的JS接口列表
    openTagList: ['wx-open-launch-app'] // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
  })
}

function onWxReady(title, link, imgUrl) {
  return new Promise((resolve, reject) => {
    /// 初始化成功
    wx.ready(function () {
      /// 初始化完成
      resolve(true)
      /// 设置微信网页"分享给朋友"的标题，封面
      wx.updateAppMessageShareData({
        title,
        link,
        desc: '来自加画框APP',
        imgUrl,
        success: function () {}
      })
      /// 分享到朋友圈
      wx.updateTimelineShareData({
        title,
        link,
        desc: '来自加画框APP',
        imgUrl,
        success: function () {}
      })
    })

    /// 初始化失败
    wx.error(function (res) {
      reject(false)
    })
  })
}

export {
  ANDROID_APPID,
  iOS_APPID,
  ANDROID_DOWNLOAD_URL,
  iOS_DOWNLOAD_URL,
  initWxWebConfig,
  onWxReady
}
